// Centralized magic numbers / app-wide constants.
// Use these instead of inlining numeric values.

export const PHONE_CAPTURE_DELAY_MS = 8000;            // delay before phone-capture popup appears
export const REACT_QUERY_STALE_TIME_MS = 60_000;        // 1 minute
export const UNLIMITED_DEVICES = 999;                   // sentinel value meaning "unlimited"
export const UNLIMITED_DEVICES_LABEL = "Unlimited";     // user-facing label for unlimited
export const TAX_RATE = 0.08;                           // 8% sales tax used on checkout summary
export const REFUND_WINDOW_DAYS = 30;                   // days a customer has to request a refund
